/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-wrapper[_ngcontent-%COMP%]{background-color:#e8eaf6;height:100%}#install[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:20px;background-color:rgba(0,0,0,.7);color:#fff;padding:1em 3em;cursor:pointer;border:none;box-shadow:5px 5px 20px rgba(0,0,0,.7);border-radius:5px}"];
export { styles as styles };
